import React, { useState, useCallback, memo, useMemo } from "react";
import PropTypes from "prop-types";
import { Input } from "@cars24/turbo-web/lib/input";
import RegNoPrefix from "./images/reg-no-prefix.svg";
import { formatInputValue } from "../input-reg-no/selector";
import { NUMBER } from "../../../constants/app-constants";

const ALPHANUMERIC = /[^a-z0-9]/gi;

const PrefixImage = memo(() => <img width={"41px"} height={"58px"} src={RegNoPrefix} alt="Reg no" />);

const InputRegNoPlateV2 = React.memo(({
    placeholder = "DL 12 AA 1234",
    onChange,
    ...rest
}) => {
    const [value, setValue] = useState("");
    const sanitizedValue = useMemo(() => formatInputValue({ inputValue: value }), [value]);

    const handleOnChange = useCallback((e) => {
        const val = e.target.value;

        if (val.length > NUMBER.FIFTEEN) {
            return;
        }
        const sanitizedVal = val.replace(ALPHANUMERIC, "");
        setValue(sanitizedVal);
        const deferSanitize = window.requestIdleCallback || window.requestAnimationFrame || window.setTimeout;
        deferSanitize(() => {
            onChange(sanitizedVal);
        }, { timeout: 100 });
    }, [onChange]);

    return (
        <Input
            type="text"
            transformValue="uppercase"
            placeholder={placeholder}
            value={sanitizedValue}
            prefix={<PrefixImage />}
            onChange={handleOnChange}
            {...rest}
        />
    );
});

InputRegNoPlateV2.propTypes = {
    placeholder: PropTypes.string,
    onChange: PropTypes.func
};

export default InputRegNoPlateV2;
